import { useQuery } from '@tanstack/react-query'
import { dataSource } from '../../service/domain/_service.config'
import { useChallengeId } from '../challenge/useChallengeId'

export const CHALLENGE_BADGES_QUERY_KEY = (challengeID: string) => ['badges', challengeID]

export function useAllBadges(challengeID?: string) {
  const defaultChallengeID = useChallengeId()
  const resolvedChallengeID = challengeID ?? defaultChallengeID

  return useQuery({
    queryKey: CHALLENGE_BADGES_QUERY_KEY(resolvedChallengeID),
    queryFn: () => dataSource.getBadges(resolvedChallengeID),
    enabled: !!resolvedChallengeID,
    staleTime: 0,
    gcTime: 0,
  })
}
